import { Box } from "@mui/material";
import React from "react";
import Sidebar from "../../../components/sidebar/sidebar";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import DiceRoller from "../../../components/Menus/autoGames/diceGame";
import WinAndSpin from "../../../components/Menus/autoGames/spinAndWin";

function SpinAndWin() {
  const params = useParams();
  return (
    <>
      <Helmet>
        <title>S - M ( M-India ) Spot-Money | SpinAndWin</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 1,
            background: `url(${process.env.PUBLIC_URL}/images/logo-background.png) center/250px no-repeat fixed `,
            minHeight: "100vh",
          }}
        >
          <Box height={{ xs: 60, md: 70 }} />

          {/* games */}
          <Box
            sx={{
              backgroundImage: "url('/spin-win/snw_1.webp')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: 4,
              height: "90vh",
            }}
          >
            <WinAndSpin />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default SpinAndWin;
